export default "__VITE_ASSET__v46XELsD__"